module.exports = __webpack_public_path__ + "img/icon_poster.0.1.0_202608111507.png";